import ListMuqeemDocumentPendinglist from "./ListMuqeemDocumentPendinglist";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIqamaData } from "./../../../../../store/Api";
import { setAppError, setBreadCrumb } from "./../../../../../store/userSlice";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import nodeinstance from "../../../../../nodeInstance";

export default function MuqeemDocumentPendingList({setData}) {
  // const IqamaData = useSelector((state) => state.iqamaData);
  // const dispatch = useDispatch();
  // const [loading, setLoading] = useState({
  //   updateData: false,
  //   uploadFile: false,
  //   listData: false,
  //   loadingId: "",
  // });
  // const [loading, setLoading] = useState(false);
  // const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //   dispatch(getIqamaData(token));
  // }, []);

  // const updateData = () => {
  //   dispatch(getIqamaData(token));
  // };

  // const [muqeemData, setMuqeemData] = useState({});

  const [trigger, setTrigger] = useState(false);

  // const MuqeemResponse = async () => {
  //   try {
  //     // setLoading(true)
  //     const response = await nodeinstance.get(`/iqama/iqammaDone/${"Muqeem"}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     if (response.status === 200) {
  //       console.log("....respone.....", response.data);
  //       setMuqeemData(response.data);
  //       // setLoading(false)
  //       // setLen(response.data.data.length);
  //     }
  //   } catch (error) {
  //     console.log("error to be seen here in console", error);
  //   }
  // };

  // useEffect(() => {
  //   MuqeemResponse();
  // }, []);

  // useEffect(() => {
  //   MuqeemResponse();
  // }, [trigger]);

  return (
    <>
      <ListMuqeemDocumentPendinglist
        titles={[
          "S.NO.",
          "EMPLOYEE ID",
          "BORDER NUMBER",
          "VISA PROVIDER",
          "SPONSOR ID",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "IQAMA RECEIVED DATE",
          "IQAMA ISSUE DATE (G)",
          "IQAMA EXPIRY DATE (G)",
          "IQAMA EXPIRY DATE (H)",
          "AGING DAYS",
          "VALID DAYS",
          "Status",
          ""
        ]}
        // list={muqeemData}
        // loading={loading}
        // setLoading={setLoading}
        // token={token}
        setTrigger={setTrigger}
        trigger={trigger}
        setData={setData}
        // updateData={MuqeemResponse()}
      />
    </>
  );
}
